import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useCallback, useMemo } from 'react';
import { PropTypes, describe } from 'react-desc';
import { uniqBy } from '@elliemae/ds-utilities/utils';
import DSComboBox from '@elliemae/ds-form/ComboBox';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var noop = function noop() {};

function SearchableList(_ref) {
  var _ref$onSelectMenuItem = _ref.onSelectMenuItem,
      onSelectMenuItem = _ref$onSelectMenuItem === void 0 ? noop : _ref$onSelectMenuItem,
      _ref$components = _ref.components,
      components = _ref$components === void 0 ? {} : _ref$components,
      _ref$searchTerm = _ref.searchTerm,
      searchTermProp = _ref$searchTerm === void 0 ? '' : _ref$searchTerm,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$dropdownFilterOp = _ref.dropdownFilterOptions,
      dropdownFilterOptions = _ref$dropdownFilterOp === void 0 ? {} : _ref$dropdownFilterOp,
      returnValue = _ref.returnValue,
      _ref$extraListProps = _ref.extraListProps,
      extraListProps = _ref$extraListProps === void 0 ? {} : _ref$extraListProps,
      _ref$appendTermInList = _ref.appendTermInList,
      appendTermInList = _ref$appendTermInList === void 0 ? false : _ref$appendTermInList,
      _ref$maxOptions = _ref.maxOptions,
      maxOptions = _ref$maxOptions === void 0 ? 10 : _ref$maxOptions,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading;

  var _useState = useState(searchTermProp),
      _useState2 = _slicedToArray(_useState, 2),
      searchTerm = _useState2[0],
      setInputValue = _useState2[1];

  var handleInputChange = useCallback(function (value, args) {
    var action = args ? args.action : null;
    if (action === 'input-blur' || action === 'menu-close') return;
    setInputValue(value);
  }, [searchTerm]);
  var handleFilterByText = useCallback(function () {
    if (searchTerm) onSelectMenuItem(searchTerm);
  }, [searchTerm]);
  var handleKeyDown = useCallback(function (e) {
    if (e.key === 'ArrowRight') {
      handleFilterByText();
    }
  }, [searchTerm]);
  var options = useMemo(function () {
    return searchTerm && appendTermInList ? uniqBy([{
      id: searchTerm,
      label: searchTerm
    }].concat(items), function (item) {
      return item.label;
    }) : items;
  }, [searchTerm, appendTermInList]);
  return /*#__PURE__*/React.createElement(DSComboBox, _extends({
    autoFocus: true,
    components: _objectSpread({
      DropdownIndicator: null
    }, components),
    customMenuItemOptions: {
      useTruncatedText: true
    },
    inlineMenu: true,
    inputValue: searchTerm,
    menuIsOpen: true,
    onChange: onSelectMenuItem,
    onFilterByInputText: handleFilterByText,
    onInputChange: handleInputChange,
    onKeyDown: handleKeyDown,
    options: options,
    returnValue: returnValue,
    valueProperty: "id",
    maxOptions: maxOptions,
    loading: loading
  }, extraListProps, dropdownFilterOptions));
}

var props = {
  /** callback after item gets selected */
  onSelectMenuItem: PropTypes.func.description('callback after item gets selected'),

  /** Object with custom components for react-select */
  components: PropTypes.shape({}).description('Object with custom components for react-select'),

  /** search term to filter for */
  searchTerm: PropTypes.string.description('search term to filter for'),

  /** item options */
  items: PropTypes.array.description('item options'),

  /** options */
  dropdownFilterOptions: PropTypes.shape({}).description('options'),

  /** Whether the combo box is has value to return or not */
  returnValue: PropTypes.bool.description('Whether the combo box is has value to return or not'),

  /** extra props to pass down to combo */
  extraListProps: PropTypes.shape({}).description('extra props to pass down to combo'),

  /** append search term as item on the list */
  appendTermInList: PropTypes.bool.description('append search term as item on the list'),

  /** maxoptions for combobox */
  maxOptions: PropTypes.number.description('maxoptions for combobox'),

  /**  loading flag */
  loading: PropTypes.bool.description('loading flag')
};
SearchableList.propTypes = props;
var DSMenuSearchableListWithSchema = describe(SearchableList);
DSMenuSearchableListWithSchema.propTypes = props;

export default SearchableList;
export { DSMenuSearchableListWithSchema };
//# sourceMappingURL=SearchableList.js.map
